export default __webpack_public_path__ + "static/media/bg.309d02ab.png";